import { atom } from "jotai";

import { BookingWizard } from "../../types";

/**
 * Represents the data our wizard will use to create the draft booking at the end
 */
export const BookingWizardDataAtom =
  atom<BookingWizard.BookingWizardData | null>(null);
